import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { ProvedorAuth } from './estado/auth'
import './estilos.css'

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Refetch ao focar a aba é ruído num painel administrativo: o operador
      // troca de janela o tempo todo e não espera a tela se mexer sozinha.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // 401 já é tratado pelo cliente (renova e repete); repetir aqui só
      // multiplicaria chamadas quando a sessão realmente caiu.
      retry: (falhas, erro) =>
        falhas < 2 && !(erro as { status?: number })?.status?.toString().startsWith('4'),
    },
  },
})

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html.')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <ProvedorAuth>
          <App />
        </ProvedorAuth>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
